import { render, staticRenderFns } from "./RelationshipField.vue?vue&type=template&id=764815a7&scoped=true&"
import script from "./RelationshipField.vue?vue&type=script&lang=ts&"
export * from "./RelationshipField.vue?vue&type=script&lang=ts&"
import style0 from "./RelationshipField.vue?vue&type=style&index=0&id=764815a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764815a7",
  null
  
)

export default component.exports